// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Rk0X","label":"SetPasswdForm_label__3DI59"};